import React, { useState, Ref, useRef } from 'react';
import {
  currentUrl, get, replaceState, URLX
} from '@polarnopyret/scope';
import ContentViewModel from 'Shared/ViewModels/ContentViewModel.type';
import CmsPageListViewModel from '../CmsPageListViewModel.type';
import CmsPageCard from './CmsPageCard';
import { styled, StyledProps } from '@glitz/react';
import { createGridClasses } from 'Shared/grid';
import { GridWrap } from 'Shared/PageLayout';
import Pagination from 'Shared/SharedComponents/atoms/Pagination';
import * as style from 'Shared/Style';

type PropType = StyledProps & {
  cmsPageList: CmsPageListViewModel;
  uppercase: boolean;
  isMobile: boolean;
  breakPoint: number;
};

export default styled((props: PropType) => {
  const {
    isMobile,
    breakPoint,
  } = props;
  
  const [cmsListViewModel, setCmsListViewModel] = useState<CmsPageListViewModel | undefined>(
    props.cmsPageList,
  );
  const topRef: Ref<HTMLDivElement> = useRef();

  const navigateToPage = (number: number) => {
    const url = currentUrl();
    url.searchParams.set('page', number.toString());
    bindFilterResults(url);
  };

  const bindFilterResults = (url: URLX) => {
    const displayUrl = url.toString();
    url.pathname = url.pathname + '/filtercms';
    if (setCmsListViewModel) {
      get(url, {})
        .then((r) => r.json())
        .then((json: CmsPageListViewModel) => {
          setCmsListViewModel(json);
          replaceState(displayUrl, null, false);
          if (topRef.current) {
            window.scrollTo({
              top: topRef.current.offsetTop - 150,
              left: 0,
              behavior: 'smooth',
            });
          }
        });
    }
  };

  let itemsPerRow: number;

  if (isMobile) {
    itemsPerRow = 2;
  } else {
    itemsPerRow = 3;
  }

  const visibleCount = cmsListViewModel.cmsPages.length;
  const itemClassName = createGridClasses(6, (12 / itemsPerRow));
  const mapping: ContentViewModel[][] = [];
  
  let row = [];
  for (let i = 0; i < visibleCount; i++) {
    row.push(cmsListViewModel.cmsPages[i]);
    if (row.length === itemsPerRow || i === visibleCount - 1) {
      mapping.push(row);
      row = [];
    }
  }

  const totalCount = cmsListViewModel.totalItemCount;
  const totalCountTitle = cmsListViewModel.labels?.displayingItems;

  return (
    <styled.Div ref={topRef}>
      {mapping.map((row: ContentViewModel[], i: number) => {
        const Row = (
          <GridWrap 
            className='grid' 
            key={i}
            css={{
              marginBottom: isMobile ? '40px' : '48px'
            }}  
          >
            {row.map((CmsPage: ContentViewModel, j: number) => {
              return (
                <CmsPageCard
                  key={j}
                  breakPoint={breakPoint}
                  isCompact={isMobile}
                  className={itemClassName}
                  cmsPage={CmsPage}
                />
              )
            })}
          </GridWrap>
        );
        return Row;
      })}
      <GridWrap>
        <Pagination
          currentPage={cmsListViewModel.currentPageIndex}
          currentlyDisplayedItemCount={visibleCount}
          pageCount={cmsListViewModel.totalPages}
          totalItemCount={totalCount}
          totalItemCountLabel={totalCountTitle}
          navigateToPage={navigateToPage}
          totalItemCountTextColor={style.colors.monochrome.a11ygrey}
        />
      </GridWrap>
    </styled.Div >
  );
});
